<dx-app-header></dx-app-header>
<router-outlet *ngIf="authService.hasAccess"></router-outlet>
<dx-header-curve *ngIf="!authService.hasAccess"></dx-header-curve>
<dx-footer></dx-footer>
